import * as React from "react";
import { makeStyles } from "@mui/styles";
import CompleteIcon from "@mui/icons-material/Done";
import InProgressIcon from "@mui/icons-material/Autorenew";
import OnHoldIcon from "@mui/icons-material/Warning";
import ReadyIcon from "@mui/icons-material/Subscriptions";

const iconBackgroundSize = 45;

const sharedStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  width: iconBackgroundSize,
  height: iconBackgroundSize
};

const useStyles = makeStyles(() => ({
  COMPLETE: {
    ...sharedStyles,
    backgroundColor: "#BBF5CB"
  },

  IN_PROGRESS: {
    ...sharedStyles,
    backgroundColor: "#2278CF"
  },

  ON_HOLD: {
    ...sharedStyles,
    backgroundColor: "#FDCDD1"
  },

  READY: {
    ...sharedStyles,
    backgroundColor: "#ECEFF1"
  }
}));

const getIconForStatus = status => {
  switch (status) {
    case "COMPLETE": {
      return <CompleteIcon style={{ color: "#30C85D" }} />;
    }
    case "IN_PROGRESS": {
      return <InProgressIcon style={{ color: "FFF" }} />;
    }
    case "ON_HOLD": {
      return <OnHoldIcon style={{ color: "#AE0C25" }} />;
    }
    case "READY": {
      return <ReadyIcon style={{ color: "#6C6D6E" }} />;
    }
    default: {
      break;
    }
  }
};

const JobStatusIcon = ({ status }) => {
  const classes = useStyles();
  const statusIcon = getIconForStatus(status);

  return <div className={classes[status]}>{statusIcon}</div>;
};

export default JobStatusIcon;
